import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import { getAllAccTable } from "../network/TableApi/tableApi";
import { useEffect, useState } from "react";
import { TableAllRes } from "../network/TableApi/tableInterfaces";

interface IProps {}

const TodayTable = (props: IProps) => {
  const [tableData, setTableData] = useState<Array<TableAllRes>>();

  useEffect(() => {
    getAllAccTable({ period: "day" }).then((res) => {
      setTableData(res);
    });
  }, []);
  const renderedRows = tableData?.map((row) => {
    const rev = [...row.orders].reverse();
    return (
      <TableRow
        key={row.account}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell component="th" scope="row">
          {row.account}
        </TableCell>
        <TableCell align="right">
          {(rev[0].amountMins / 100).toFixed(2)}
        </TableCell>
        <TableCell align="right">{rev[0].factInc.toFixed(2)}</TableCell>
        <TableCell align="right">{rev[0].margin}</TableCell>
        <TableCell align="right">{rev[0].drawdown}</TableCell>
      </TableRow>
    );
  });
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Название счета</TableCell>
            <TableCell align="right">Сегодня $</TableCell>
            <TableCell align="right">Сегодня %</TableCell>
            <TableCell align="right">Маржа</TableCell>
            <TableCell align="right">Просадка</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{renderedRows}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default TodayTable;
